import * as React from 'react';

export interface FormWithCancelButtonProps {
    onClose?: () => void;
}

export class FormWithCancelButton<T> extends React.Component<T & FormWithCancelButtonProps> {
    cancel = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }
}